// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cards-ejercicios{
    display: flex;
    overflow-x: scroll;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/trainer-dashboard/programas/config-avanzada/progreso-cliente/progreso-cliente.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;AACtB","sourcesContent":[".cards-ejercicios{\n    display: flex;\n    overflow-x: scroll;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
